import React from 'react'

import { BRIDGE_SITE_LINK_PROPS } from '@/constants/bridgeLink'
import { cn } from '@/lib/utils'

type BridgeSiteLinkProps = React.ComponentPropsWithoutRef<'a'>

export function BridgeSiteLink({ className, children, ...rest }: BridgeSiteLinkProps) {
  return (
    <a {...BRIDGE_SITE_LINK_PROPS} className={cn(className)} {...rest}>
      {children}
    </a>
  )
}
